export const PHASES = ["Discovery", "Design Concept", "Procurement", "Installation", "Complete"];

export const PHASE_COLORS = {
  Discovery: "#A68A6B",
  "Design Concept": "#8C7154",
  Procurement: "#C49A4A",
  Installation: "#506B52",
  Complete: "#5C5651",
};

export default function PhaseStepper({ status, showLabels = false }) {
  const idx = Math.max(0, PHASES.indexOf(status));
  return (
    <div data-testid="phase-stepper">
      <div className="flex gap-1">
        {PHASES.map((p, i) => (
          <div key={p} data-testid={`phase-seg-${i}`} className="flex-1 h-1.5 transition-colors"
            style={{ background: i <= idx ? "#A68A6B" : "#F2EFEB" }} />
        ))}
      </div>
      {showLabels && (
        <div className="flex justify-between mt-2">
          {PHASES.map((p, i) => (
            <span key={p} className="text-[10px] uppercase tracking-wider"
              style={{ color: i <= idx ? "#A68A6B" : "#9b938b", fontWeight: i === idx ? 600 : 400 }}>
              {p}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
